module.exports = __webpack_public_path__ + "static/media/cart.808d105c.svg";